module.exports = __webpack_public_path__ + "static/avatar_af-8e9751c7858eab70467d022556eaa12d.png";